import React from 'react';
import { listPublished, type PublishedSummary } from '../../api/publishedAppsApi';
import { useAuth } from '../../context/AuthContext';
import ChangePassword from '../Auth/ChangePassword';
import IncludedApps from '../IncludedApps/IncludedApps';
import styles from '../Management.module.css';
import AppIcon from '../Identity/AppIcon';
import {usePageIdentity} from '../Identity/BrowserIdentity';

export default function AppCatalog():React.ReactElement {
  const {user,logout}=useAuth();
  usePageIdentity('Applications');
  const [apps,setApps]=React.useState<PublishedSummary[]>([]),[error,setError]=React.useState(''),[loading,setLoading]=React.useState(true);
  React.useEffect(()=>{listPublished().then(setApps).catch(()=>setError('Published applications could not be loaded. Refresh this page to try again.')).finally(()=>setLoading(false));},[]);
  return <main className={styles.page} style={{margin:'40px auto',padding:24}}>
    <div className={styles.header}><div><h1>Applications</h1><p className={styles.muted}>Signed in as {user?.displayName||user?.username}</p></div><button className={styles.button} onClick={()=>void logout()}>Sign out</button></div>
    <h2>Published for your workspace</h2>
    {error&&<p role="alert" className={styles.error}>{error}</p>}
    {loading&&<p role="status">Loading applications…</p>}
    {!loading&&!error&&!apps.length&&<p className={styles.empty}>No Conductor applications are currently published.</p>}
    <div className={styles.grid}>{apps.map(app=><article key={app.slug} className={styles.card}>
      <div className={styles.titleRow}><AppIcon iconPath={app.iconPath}/><h3>{app.displayName}</h3></div><p className={styles.muted}>{app.description}</p><small className={styles.muted}>{app.visibility==='public'?'Public':'Sign-in required'} · Version {app.version}</small>
      <div className={styles.actions}><a className={styles.primary} href={'/apps/'+app.slug}>Open {app.displayName}</a></div>
    </article>)}</div>
    <IncludedApps />
    <section className={styles.section}><ChangePassword/></section>
  </main>;
}
